import { render, staticRenderFns } from "./task-summary.vue?vue&type=template&id=27a00cb9&"
import script from "./task-summary.vue?vue&type=script&lang=js&"
export * from "./task-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a00cb9')) {
      api.createRecord('27a00cb9', component.options)
    } else {
      api.reload('27a00cb9', component.options)
    }
    module.hot.accept("./task-summary.vue?vue&type=template&id=27a00cb9&", function () {
      api.rerender('27a00cb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/task-summary.vue"
export default component.exports